import Video, { ConnectOptions, LocalTrack, Room, TwilioError } from 'twilio-video';
import { useCallback, useEffect, useRef, useState } from 'react';
import EventEmitter from 'events';

export default function useRoom(
  localTracks: LocalTrack[],
  onError: (e: TwilioError) => void,
  defaultOptions?: ConnectOptions
) {
  const [room, setRoom] = useState<Room>(new EventEmitter() as Room);
  const [isConnecting, setIsConnecting] = useState(false);

  const localTracksRef = useRef<LocalTrack[]>([]);
  useEffect(() => {
    localTracksRef.current = localTracks;
  }, [localTracks]);

  const connect = useCallback(
    async (token: string, overrideOptions: ConnectOptions): Promise<Room> => {
      setIsConnecting(true);
      try {
        const connectOpts: ConnectOptions = {
          ...defaultOptions,
          ...overrideOptions,
          tracks: overrideOptions.tracks ?? localTracksRef.current,
        };

        const newRoom = await Video.connect(token, connectOpts);
        setRoom(newRoom);
        return newRoom;
      } catch (err) {
        onError(err as TwilioError);
        throw err;
      } finally {
        setIsConnecting(false);
      }
    },
    [defaultOptions, onError]
  );

  return { room, isConnecting, connect };
}
